export default {
  namespaced: true,
  patrol_logs: {
    title: "Patrullaje",
    add_unit_log: "Agregar Registro de Bitácora",
    patrol_log: {
      title: "Bitácora de patrullaje",
      unit_log: "Bitácora de Unidad",
      select_unit_log: "Seleccionar bitácora de unidad",
      unit: "Inmueble",
      select_unit: "Seleccionar unidad",
      shipping_time: "Hora de Envío",
      arrival_time: "Hora de Llegada",
      departure_time: "Hora de Salida",
      revision_code: "Claves Operativas",
      select_revision_code: "Selecciona la clave operativa",
      comments: "Comentarios",
      assignment: "Asignación",
      surveillance: "En seguimiento",
      command_officer: "Comandante",
      select_command_officer: "Seleccionar comandante",
      patrol_officer: "Oficial de patrulla",
      select_patrol_officer: "Seleccionar oficial de patrulla",
      created_success: "Bitácora de patrulla creada exitosamente",
      updated_success: "Bitácora de patrulla actualizada exitosamente",
      deleted_success: "Bitácora de patrulla eliminada exitosamente",
      review_time: "Tiempo de revisión",
      travel_time: "Tiempo de traslado",
    },
    unit_log: {
      title: "Registro de unidades",
      unit: "Número de unidad",
      select_unit: "Seleccionar unidad",
      commander: "Comandante",
      select_commander: "Seleccionar comandante",
      patrol_office: "Oficial de Patrulla",
      telephone_number: "Número de Teléfono de la Unidad",
      router_number: "Número de Ruta",
      active: "Activo",
      select_status: "Seleccionar estado",
      created_success: "Bitácora de unidad creada exitosamente",
      updated_success: "Bitácora de unidad actualizada exitosamente",
      deleted_success: "Bitácora de unidad eliminada exitosamente",
    },
    unit_commander: {
      title: "Patrulleros",
      name: "Nombre",
      telephone_number: "Número de Teléfono",
      placeholder_name: "Ingrese nombre",
      placeholder_telephone: "Ingrese número de teléfono",
      no_filters: "No hay filtros disponibles",
      created_success: "Comandante de unidad creado exitosamente",
      updated_success: "Comandante de unidad actualizado exitosamente",
      deleted_success: "Comandante de unidad eliminado exitosamente",
    },
    revision_code: {
      title: "Claves Operativas",
      name: "Nombre",
      code: "Código",
      placeholder_name: "Ingrese el nombre",
      placeholder_code: "Ingrese el código",
      no_filters: "No hay filtros disponibles",
      created_success: "Código de revisión creado correctamente",
      updated_success: "Código de revisión actualizado correctamente",
      deleted_success: "Código de revisión eliminado correctamente",
    },
  },
};
